$(document).ready(function () {
  if (theme.protection_product != "") {
    $("body").on("change", ".select-condition input", function () {
      var $chk = $(this);
      var product = $chk.data("id");
      console.log("shipping prot", product);
      if ($chk.prop('checked')) {
        var action = "add";
        var items = {
          id: product,
          quantity: 1,
          properties: {
            hidden: "yes",
            exclude_tier_discounts: "yes",
          },
        };
        giftAddRemove(items, action);
      } else {
        var action = "change";
        var items = {
          id: product,
          quantity: 0,
        };
        giftAddRemove(items, action);
      }
    });

    //Shipping Protection end
    jQuery.getJSON("/cart.js", function (cart) {
      var id = $(".select-condition input").data("id");
      var d = cart.items.filter((el) => {
        return el.id == id;
      })[0];
      if (d == undefined) {
        var free_prod_qty = "undefined";
      } else {
        var free_prod_qty = d.quantity;
      }
      if (free_prod_qty.quantity == 0 || free_prod_qty == "undefined") {
        $(".select-condition input").prop("checked", false);
      } else {
        $(".select-condition input").prop("checked", true);
      }
    });
  }
});

if (theme.gift_tier == true) {
  jQuery.getJSON("/cart.js", function (cart) {
    GiftMsg(cart);
    var id = $(".select-condition input").data("id");
    var cart_total = cart.total_price;
    var d = cart.items.filter((el) => {
      return el.id == id;
    })[0];
    if (d == undefined) {
      var free_prod_qty = "undefined";
    } else {
      var free_prod_qty = d.quantity;
    }
    if (free_prod_qty.quantity == 0 || free_prod_qty == "undefined") {
      $(".select-condition input").prop("checked", false);
    } else {
      $(".select-condition input").prop("checked", true);
    }
    if (cart_total > thresold_1) {
      $(".campusprotein-progress-bar-2").css("width", "35%");
    }
    if (cart_total > thresold_2) {
      $(".campusprotein-progress-bar-2").css("width", "65%");
    }
    if (cart_total > thresold_3) {
      $(".campusprotein-progress-bar-2").css("width", "100%");
    }
  });

  function get_bundle_products(data) {
    var bundle_types = [],
      normal_products = [];
    data.items.forEach(function (item, index) {
      let Hasbundle_type = false;
      if (
        !$.isEmptyObject(item.properties) &&
        item.properties.gift_product != undefined
      ) {
        $.each(item.properties, function (title, value) {
          if (value == "yes") {
            Hasbundle_type = true;
            bundle_types.push(item);
            return false;
          }
        });
      }
    });
    var unique_bundles = bundle_types.filter(function (item, i, ar) {
      return ar.indexOf(item) === i;
    });
    data.items.forEach(function (item, index) {
      let Hasbundle_type = false;
      if ($.isEmptyObject(item.properties)) {
        normal_products.push(item);
      }
    });
    return {
      tier_products: unique_bundles,
      normal_products: normal_products,
    };
  }

  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      var d = get_bundle_products(cart);
      if (d.tier_products.length > 0 && d.normal_products.length == 0) {
        $.ajax({
          type: "POST",
          url: "/cart/clear.js",
          data: "",
          dataType: "json",
          success: function (data) {
            document.dispatchEvent(
              new CustomEvent("ajaxProduct:added", {
                detail: {
                  product: data,
                  addToCartBtn: null,
                },
              })
            );
          },
        });
      }
    });

  document.addEventListener("ajaxProduct:added", function (evt) {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        GiftMsg(cart);
        var cart_total = cart.total_price;
        var d = get_bundle_products(cart);
        if (d.tier_products.length > 0 && d.normal_products.length == 0) {
          $(".campusprotein-top").empty();
          $.ajax({
            type: "POST",
            url: "/cart/clear.js",
            data: "",
            dataType: "json",
            success: function (data) {
              document.dispatchEvent(
                new CustomEvent("ajaxProduct:added", {
                  detail: {
                    product: data,
                    addToCartBtn: null,
                  },
                })
              );
            },
          });
        }
        if (cart_total >= thresold_3) {
          //add 3rd free product   or free
          if (gift_product[2].tier_3 != "") {
            $(".campusprotein-progress-bar-2").css("width", "100%");
            check_eligibility(gift_product[2].tier_3, cart);
          }
        } else if (cart_total >= thresold_2) {
          //add 2rd free product   or free
          if (gift_product[1].tier_2 != "") {
            $(".campusprotein-progress-bar-2").css("width", "65%");
            check_eligibility(gift_product[1].tier_2, cart);
          }
        } else if (cart_total >= thresold_1) {
          //add 1st free product
          $(".campusprotein-progress-bar-2").css("wid ,cartth", "35%");
          if (gift_product[0].tier_1 != "") {
            check_eligibility(gift_product[0].tier_1, cart);
          }
        }
        if (cart_total >= thresold_2 && gift_product[0].tier_1 != "") {
          check_eligibility(gift_product[0].tier_1, cart);
        }
        if (cart_total >= thresold_3 && gift_product[1].tier_2 != "") {
          check_eligibility(gift_product[1].tier_2, cart);
        }

        //When quantity minus...
        if (cart_total <= thresold_3 && cart_total >= thresold_2) {
          //remove 3rd free product or free shipping
          $(".campusprotein-progress-bar-2").css("width", "65%");
          removeEligibility(gift_product[2].tier_3, cart);
        } else if (cart_total <= thresold_2 && cart_total >= thresold_1) {
          //remove 2nd free product or free shipping
          $(".campusprotein-progress-bar-2").css("width", "35%");
          removeEligibility(gift_product[1].tier_2, cart);
          removeEligibility(gift_product[2].tier_3, cart);
        } else if (cart_total <= thresold_1) {
          //remove 1st free product or free shipping
          $(".campusprotein-progress-bar-2").css("width", "0%");
          removeEligibility(gift_product[0].tier_1, cart);
        }
      });
  });
}

function check_eligibility(eligibility, cart) {
  if (eligibility == "free-shipping") {
    free_shipping("yes");
  } else {
    var id_to_check = eligibility;
    var d = cart.items.filter((el) => {
      return el.id == id_to_check;
    })[0];
    if (d == undefined) {
      var free_prod_qty = "undefined";
    } else {
      var free_prod_qty = d.quantity;
    }
    if (free_prod_qty == 0 || free_prod_qty == "undefined") {
      var action = "add";
      var items = {
        id: id_to_check,
        quantity: 1,
        properties: {
          gift_product: "yes",
        },
      };
      giftAddRemove(items, action);
    } else {
      var action = "update";
      var items = {
        id: id_to_check,
        quantity: 1,
        properties: {
          gift_product: "yes",
        },
      };
      // giftAddRemove(items , action);
    }
  }
}
//when quantity minus delete the tier wise free product
function removeEligibility(eligibility, cart) {
  if (eligibility == "free-shipping") {
    free_shipping("");
  } else {
    var id_to_check = eligibility;
    var d = cart.items.filter((el) => {
      return el.id == id_to_check;
    })[0];
    if (d == undefined) {
      var free_prod_qty = "undefined";
    } else {
      var free_prod_qty = d.quantity;
    }
    if (free_prod_qty > 0) {
      var action = "change";
      var items = {
        id: id_to_check,
        quantity: 0,
      };
      giftAddRemove(items, action);
    }
  }
}
function giftAddRemove(items, action) {
  $.ajax({
    type: "POST",
    url: "/cart/" + action + ".js",
    dataType: "json",
    data: items,
    success: function (data) {
      document.dispatchEvent(
        new CustomEvent("ajaxProduct:added", {
          detail: {
            product: data,
            addToCartBtn: null,
          },
        })
      );
    },
    error: function (error) {
      console.log("error", error);
    },
  });
}
function free_shipping(note_val) {
  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      "Content-Type": "application/json;",
    },
    body: JSON.stringify({
      attributes: {
        free_shipping: note_val,
      },
    }),
  });
}
function GiftMsg(cart) {
  if (cart.total_price <= thresold_1) {
    var away = thresold_1 - cart.total_price;
    var msg = msg1.replaceAll("XX", theme.Currency.formatMoney(away));
    if (gift_product[0].tier_1 != "") {
      $(".campusprotein-top").empty().html(msg);
    }
  } else if (cart.total_price <= thresold_2) {
    var away = thresold_2 - cart.total_price;
    var msg = msg2.replaceAll("XX", theme.Currency.formatMoney(away));
    if (gift_product[1].tier_2 != "") {
      $(".campusprotein-top").empty().html(msg);
    }
  } else if (cart.total_price <= thresold_3) {
    var away = thresold_3 - cart.total_price;
    var msg = msg3.replaceAll("XX", theme.Currency.formatMoney(away));
    if (gift_product[2].tier_3 != "") {
      $(".campusprotein-top").empty().html(msg);
    }
  } else if (cart.total_price >= thresold_3) {
    $(".campusprotein-top").empty().text(qul_msg);
  }
}

if (theme.offer_progressbar == true) {
  offer_progressbar();
  document.addEventListener("ajaxProduct:added", function (evt) {
    offer_progressbar();
  });
}
function offer_progressbar() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      var cart_total = cart.total_price;
      if (
        cart_total >= discount_thresold_1 &&
        cart_total < discount_thresold_2 &&
        discount_thresold_1 != ""
      ) {
        var away = discount_thresold_2 - cart_total;
        var msg1 = second_before_msg.replaceAll(
          "XX",
          theme.Currency.formatMoney(away)
        );
        $(".offer-progressbar_txtop").empty().html(msg1);
        $(".offer-progressbar_txbottom").empty().html(first_after_msg);
        $(".offer-progressbar-inner").css("width", "25%");
        $(".count-30").removeClass("qualify");
        $(".count-60").removeClass("qualify");
        $(".count-10").addClass("qualify");
      } else if (
        cart_total >= discount_thresold_1 &&
        discount_thresold_2 == "" &&
        discount_thresold_3 == ""
      ) {
        $(".offer-progressbar-inner").css("width", "100%");
        $(".offer-progressbar_txtop").empty();
        $(".offer-progressbar_txbottom").empty();
        $(".count-10").addClass("qualify");
      } else if (
        discount_thresold_1 == "" &&
        cart_total >= discount_thresold_2 &&
        discount_thresold_3 == ""
      ) {
        $(".offer-progressbar-inner").css("width", "100%");
        $(".offer-progressbar_txtop").empty();
        $(".offer-progressbar_txbottom").empty();
        $(".count-30").addClass("qualify");
      } else if (
        discount_thresold_1 == "" &&
        cart_total < discount_thresold_2 &&
        discount_thresold_3 == ""
      ) {
        $(".offer-progressbar-inner").css("width", "0%");
        var away = discount_thresold_2 - cart_total;
        var msg1 = second_before_msg.replaceAll(
          "XX",
          theme.Currency.formatMoney(away)
        );
        $(".offer-progressbar_txtop").empty().html(msg1);
        $(".offer-progressbar_txbottom").empty();
        $(".count-30").removeClass("qualify");
      } else if (
        discount_thresold_1 == "" &&
        discount_thresold_2 == "" &&
        cart_total < discount_thresold_3 &&
        discount_thresold_3 != ""
      ) {
        $(".offer-progressbar-inner").css("width", "0%");
        var away = discount_thresold_3 - cart_total;
        var msg1 = third_before_msg.replaceAll(
          "XX",
          theme.Currency.formatMoney(away)
        );
        $(".offer-progressbar_txtop").empty().html(msg1);
        $(".offer-progressbar_txbottom").empty();
        $(".count-60").removeClass("qualify");
      } else if (
        discount_thresold_1 == "" &&
        discount_thresold_2 != "" &&
        discount_thresold_3 == ""
      ) {
        var away = discount_thresold_2 - cart_total;
        var msg1 = second_before_msg.replaceAll(
          "XX",
          theme.Currency.formatMoney(away)
        );
        $(".offer-progressbar_txtop").empty().html(msg1);
        $(".offer-progressbar_txbottom").empty();
      } else if (
        cart_total >= discount_thresold_2 &&
        cart_total < discount_thresold_3 &&
        discount_thresold_2 != ""
      ) {
        var away = discount_thresold_3 - cart_total;
        var msg1 = third_before_msg.replaceAll(
          "XX",
          theme.Currency.formatMoney(away)
        );
        $(".offer-progressbar_txtop").empty().html(msg1);
        $(".offer-progressbar_txbottom").empty().html(second_after_msg);
        $(".offer-progressbar-inner").css("width", "50%");
        $(".count-10").addClass("qualify");
        $(".count-60").removeClass("qualify");
        $(".count-30").addClass("qualify");
      } else if (
        cart_total >= discount_thresold_1 &&
        cart_total < discount_thresold_3 &&
        discount_thresold_1 != ""
      ) {
        var away = discount_thresold_3 - cart_total;
        var msg1 = third_before_msg.replaceAll(
          "XX",
          theme.Currency.formatMoney(away)
        );
        $(".offer-progressbar_txtop").empty().html(msg1);
        $(".offer-progressbar_txbottom").empty().html(first_after_msg);
        $(".offer-progressbar-inner").css("width", "25%");
        $(".count-10").addClass("qualify");
        $(".count-60").removeClass("qualify");
      } else if (
        cart_total >= discount_thresold_3 &&
        discount_thresold_3 != ""
      ) {
        $(".offer-progressbar_txtop").empty().html(third_after_msg);
        $(".offer-progressbar_txbottom").empty();
        $(".offer-progressbar-inner").css("width", "100%");
        $(".count-10").addClass("qualify");
        $(".count-30").addClass("qualify");
        $(".count-60").addClass("qualify");
      } else if (
        cart_total >= discount_thresold_2 &&
        discount_thresold_3 == "" &&
        discount_thresold_2 != ""
      ) {
        $(".offer-progressbar_txtop").empty().html(second_after_msg);
        $(".offer-progressbar_txbottom").empty();
        $(".offer-progressbar-inner").css("width", "100%");
        $(".count-10").addClass("qualify");
        $(".count-30").addClass("qualify");
        $(".count-60").removeClass("qualify");
      } else {
        var away = discount_thresold_1 - cart_total;
        var msg1 = first_before_msg.replaceAll(
          "XX",
          theme.Currency.formatMoney(away)
        );
        $(".offer-progressbar_txtop").empty().html(msg1);
        $(".offer-progressbar_txbottom").empty();
        $(".offer-progressbar-inner").css("width", "0%");
        $(".count-30").removeClass("qualify");
        $(".count-60").removeClass("qualify");
        $(".count-10").removeClass("qualify");
      }
    });
}

if (theme.quantity_offer_progressbar == true) {
  quantity_offer_progressbar();
  document.addEventListener("ajaxProduct:added", function (evt) {
    quantity_offer_progressbar();
  });
}
function quantity_offer_progressbar() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      var protection_product = cart.items.filter((item) => {
        if (
          item.properties.exclude_tier_discounts ||
          item.product_id == 6793937322059 ||
          item.properties.bogo_discount
        ) {
          return item;
        }
      });
      var sum = 0;
      protection_product.forEach((item) => {
        sum += item.quantity;
      });
      if (sum > 0) {
        var energy_length = cart.item_count - sum;
      } else {
        var energy_length = cart.item_count;
      }
      // console.log('energy' ,protection_product)
      if (
        energy_length >= discount_thresold_1 &&
        energy_length < discount_thresold_2 &&
        discount_thresold_1 != ""
      ) {
        var away = discount_thresold_2 - energy_length;
        var msg1 = second_before_msg.replaceAll("XX", "<b>" + away + "</b>");
        $(".offer-progressbar_txtop").empty().html(msg1);
        $(".offer-progressbar_txbottom").empty().html(first_after_msg);
        $(".offer-progressbar-inner").css("width", "25%");
        $(".count-30").removeClass("qualify");
        $(".count-60").removeClass("qualify");
        $(".count-10").addClass("qualify");
      } else if (
        energy_length >= discount_thresold_1 &&
        discount_thresold_2 == "" &&
        discount_thresold_3 == ""
      ) {
        $(".offer-progressbar-inner").css("width", "100%");
        $(".offer-progressbar_txtop").empty();
        $(".offer-progressbar_txbottom").empty();
        $(".count-10").addClass("qualify");
      } else if (
        discount_thresold_1 == "" &&
        energy_length >= discount_thresold_2 &&
        discount_thresold_3 == ""
      ) {
        $(".offer-progressbar-inner").css("width", "100%");
        $(".offer-progressbar_txtop").empty();
        $(".offer-progressbar_txbottom").empty();
        $(".count-30").addClass("qualify");
      } else if (
        discount_thresold_1 == "" &&
        energy_length < discount_thresold_2 &&
        discount_thresold_3 == ""
      ) {
        $(".offer-progressbar-inner").css("width", "0%");
        var away = discount_thresold_2 - energy_length;
        var msg1 = second_before_msg.replaceAll("XX", "<b>" + away + "</b>");
        $(".offer-progressbar_txtop").empty().html(msg1);
        $(".offer-progressbar_txbottom").empty();
        $(".count-30").removeClass("qualify");
      } else if (
        discount_thresold_1 == "" &&
        discount_thresold_2 == "" &&
        energy_length < discount_thresold_3 &&
        discount_thresold_3 != ""
      ) {
        $(".offer-progressbar-inner").css("width", "0%");
        var away = discount_thresold_3 - energy_length;
        var msg1 = third_before_msg.replaceAll("XX", "<b>" + away + "</b>");
        $(".offer-progressbar_txtop").empty().html(msg1);
        $(".offer-progressbar_txbottom").empty();
        $(".count-60").removeClass("qualify");
      } else if (
        discount_thresold_1 == "" &&
        discount_thresold_2 != "" &&
        discount_thresold_3 == ""
      ) {
        var away = discount_thresold_2 - energy_length;
        var msg1 = second_before_msg.replaceAll("XX", "<b>" + away + "</b>");
        $(".offer-progressbar_txtop").empty().html(msg1);
        $(".offer-progressbar_txbottom").empty();
      } else if (
        energy_length >= discount_thresold_2 &&
        energy_length < discount_thresold_3 &&
        discount_thresold_2 != ""
      ) {
        var away = discount_thresold_3 - energy_length;
        var msg1 = third_before_msg.replaceAll("XX", "<b>" + away + "</b>");
        $(".offer-progressbar_txtop").empty().html(msg1);
        $(".offer-progressbar_txbottom").empty().html(second_after_msg);
        $(".offer-progressbar-inner").css("width", "50%");
        $(".count-10").addClass("qualify");
        $(".count-60").removeClass("qualify");
        $(".count-30").addClass("qualify");
      } else if (
        energy_length >= discount_thresold_1 &&
        energy_length < discount_thresold_3 &&
        discount_thresold_1 != ""
      ) {
        var away = discount_thresold_3 - energy_length;
        var msg1 = third_before_msg.replaceAll("XX", "<b>" + away + "</b>");
        $(".offer-progressbar_txtop").empty().html(msg1);
        $(".offer-progressbar_txbottom").empty().html(first_after_msg);
        $(".offer-progressbar-inner").css("width", "25%");
        $(".count-10").addClass("qualify");
        $(".count-60").removeClass("qualify");
      } else if (
        energy_length >= discount_thresold_3 &&
        discount_thresold_3 != ""
      ) {
        $(".offer-progressbar_txtop").empty().html(third_after_msg);
        $(".offer-progressbar_txbottom").empty();
        $(".offer-progressbar-inner").css("width", "100%");
        $(".count-10").addClass("qualify");
        $(".count-30").addClass("qualify");
        $(".count-60").addClass("qualify");
      } else if (
        energy_length >= discount_thresold_2 &&
        discount_thresold_3 == "" &&
        discount_thresold_2 != ""
      ) {
        $(".offer-progressbar_txtop").empty().html(second_after_msg);
        $(".offer-progressbar_txbottom").empty();
        $(".offer-progressbar-inner").css("width", "100%");
        $(".count-10").addClass("qualify");
        $(".count-30").addClass("qualify");
        $(".count-60").removeClass("qualify");
      } else {
        var away = discount_thresold_1 - energy_length;
        var msg1 = first_before_msg.replaceAll("XX", "<b>" + away + "</b>");
        $(".offer-progressbar_txtop").empty().html(msg1);
        $(".offer-progressbar_txbottom").empty();
        $(".offer-progressbar-inner").css("width", "0%");
        $(".count-30").removeClass("qualify");
        $(".count-60").removeClass("qualify");
        $(".count-10").removeClass("qualify");
      }
    });
}
